var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,5 L1,5 L1,3 C1,2.448 1.448,2 2,2 L16,2 C16.552,2 17,2.448 17,3 L17,5 Z M17,16 C17,16.552 16.552,17 16,17 L2,17 C1.448,17 1,16.552 1,16 L1,6 L17,6 L17,16 Z M16,1 L15,1 L15,0 L14,0 L14,1 L4,1 L4,0 L3,0 L3,1 L2,1 C0.897,1 0,1.897 0,3 L0,16 C0,17.103 0.897,18 2,18 L16,18 C17.103,18 18,17.103 18,16 L18,3 C18,1.897 17.103,1 16,1 L16,1 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.9d08678e9dc868e850ec3a237b630b9e.svg";
export { ForwardRef as ReactComponent };